import styled from '@emotion/styled';
import { claudeTokens } from '@/styles/claudeTokens';
import { AccountPageHeader, AccountPageShell } from '@/components/common/organism/AccountPageLayout';

/**
 * 바깥 틀은 다른 화면과 같은 흰 셸(헤더 폭 1260·24, 폰 본문 좌우 16px) — 가운데 860px 이던 것(2026-10-11 C3).
 * 본문 줄 길이는 읽기 좋게 예전 글 칸 폭(820px)을 넘지 않게 두고, 제목과 같은 왼쪽 기준선에 붙인다.
 */
const Page = styled(AccountPageShell)`
    padding-bottom: 48px;
    @media (max-width: 768px) { padding-bottom: 32px; }
`;

const Body = styled.pre`
    max-width: 820px;
    white-space: pre-wrap;
    word-break: keep-all;
    overflow-wrap: anywhere;
    font-family: inherit;
    font-size: 0.92rem;
    line-height: 1.85;
    color: ${claudeTokens.color.text2};
    margin: 0;
`;

interface LegalDocumentProps {
    title: string;
    version?: string;
    content: string;
}

/** 약관·개인정보처리방침 등 법적 고지 문서를 렌더링하는 공통 페이지 컴포넌트. */
const LegalDocument = ({ title, version, content }: LegalDocumentProps) => {
    return (
        <Page>
            <AccountPageHeader title={title} subtitle={version ? `시행일 / 버전: ${version}` : undefined} />
            <Body>{content}</Body>
        </Page>
    );
};

export default LegalDocument;
